import { render, staticRenderFns } from "./AgeRequirementMonthsInput.vue?vue&type=template&id=90d9342a&"
import script from "./AgeRequirementMonthsInput.vue?vue&type=script&lang=js&"
export * from "./AgeRequirementMonthsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports